import { Head, Link } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import type { Copy, Publication } from '@/frontend/features/DashboardRuntime/types'
import PublicationByline from '@/frontend/features/DashboardRuntime/PublicationByline'

type Project = { id: string; name: string }
function Index({ project, publications, copy }: { project: Project | null; publications: (Omit<Publication, 'schema'> & { project: Project })[]; copy: Copy }) {
  return <main className="mx-auto w-full max-w-6xl space-y-8 p-6 md:p-10">
    <Head title={project ? `${copy.title} · ${project.name}` : copy.title} />
    <header><p className="text-sm text-muted-foreground">{project?.name ?? copy.catalog_description}</p><h1 className="mt-2 text-2xl font-semibold">{copy.title}</h1></header>
    {!publications.length && <p className="rounded-xl border p-8 text-muted-foreground">{copy.empty}</p>}
    <div className="grid gap-4 md:grid-cols-2">{publications.map((publication) => <Link key={publication.id}
      href={`/dashboard/projects/${publication.project.id}/dashboards/${publication.id}`} className="rounded-xl border bg-card p-6 transition-colors hover:border-primary">
      {!project && <p className="mb-2 text-xs font-medium text-muted-foreground">{publication.project.name}</p>}
      <h2 className="font-semibold">{publication.title}</h2>
      <div className="mt-3"><PublicationByline publication={publication} copy={copy} /></div>
      {(publication.pending || !publication.version) && <p className="mt-2 text-sm text-muted-foreground">{publication.pending ? copy.pending : copy.unpublished}</p>}
    </Link>)}</div>
  </main>
}
Index.layout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>
export default Index
